import Dashboard from './dashboard'
export const MobileInternalContent = {
    Dashboard
}